"use client"

import { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { DeviceManualControls } from "@/components/device-manual-controls"
import { useManualModeStore } from "@/lib/manual-mode-store"
import { useDeviceStore } from "@/lib/device-store"
import { Gauge } from "@/lib/icons"

export function DeviceManualIndicator() {
  const { isActive, speed } = useManualModeStore()
  const { getActiveDevice } = useDeviceStore()
  const device = getActiveDevice()
  const [open, setOpen] = useState(false)

  if (!device?.isConnected || !isActive) return null

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 px-3 py-2 rounded-2xl bg-background/80 backdrop-blur-md border border-indigo-500/40 shadow-xl shadow-black/20 hover:border-indigo-400/60 transition-colors"
        >
          <span className="relative flex h-2 w-2 shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500" />
          </span>
          <Gauge className="h-3.5 w-3.5 text-indigo-400 shrink-0" />
          <span className="text-xs font-medium">{device.name}</span>
          <span className="text-[10px] tabular-nums text-muted-foreground">{speed}%</span>
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="end" className="w-64 p-4" sideOffset={8}>
        <DeviceManualControls compact />
      </PopoverContent>
    </Popover>
  )
}
